import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import React, { useCallback, useMemo, useState } from "react";
import { View, FlatList } from "react-native";
import ListTile from "./components/ListTile";
import { getRoutingList } from "@services/api";
import { useFocusEffect } from "@react-navigation/native";
import { useSelector, shallowEqual } from "react-redux";
import { t } from "@constants/localization";

const Routing = ({ navigation, route }) => {
  const [data, setData] = useState({});
  const { nav_params } = route.params;
  const isCmoCp = useSelector(
    ({ auth }) => Boolean(auth?.user?.is_cmo_cp),
    shallowEqual,
  );
  const fetchData = async () => {
    try {
      // eslint-disable-next-line no-shadow
      const { data } = await getRoutingList();
      setData(data?.data);
    } catch (error) {
      console.error("Error fetching Routing List: ", error);
    }
  };

  useFocusEffect(
    useCallback(() => {
      fetchData();
    }, []),
  );
  const listData = useMemo(
    () => [
      {
        title: "Assign Routes",
        type: "ASSIGN_ROUTES",
        subtitle_1: "Pending Customers :",
        subtitle_1_value: data?.routing_pending_cx,
        nav_to: "CpDeliveryRoutes",
        // Hidden for dark store CPs (routing-details
        // `assign_routes_enabled: false`); shown when the field is missing.
        show_card: data?.assign_routes_enabled !== false,
      },
      {
        title: "Manage Routes",
        type: "MANAGE_ROUTES",
        subtitle_1: "DB Unassigned Routes:",
        subtitle_1_value: data?.routing_unassigned_cpdb_routes,
        nav_to: "DeliveryRouteList",
        // Hidden for dark store CPs (`manage_routes_enabled: false`).
        show_card: data?.manage_routes_enabled !== false,
      },
      {
        title: "Partner Routing & Packing",
        type: "PARTNER_ROUTING_AND_PACKING",
        nav_to: "PartnerRoutingAndPacking",
        // CMO CPs, except dark stores (`partner_routing_packing_enabled: false`).
        show_card: isCmoCp && data?.partner_routing_packing_enabled !== false,
      },
      // Dark store CPs only (routing-details `ds_routing_enabled`): the one
      // routing entry they see.
      {
        title: t("DsRouting/title"),
        type: "DS_ROUTING",
        nav_to: "DsRoutingHub",
        show_card: Boolean(data?.ds_routing_enabled),
      },
    ],
    [data, nav_params, isCmoCp],
  );

  const renderItem = ({ item }) => <ListTile item={item} />;

  return (
    <View style={{ flex: 1, backgroundColor: "#fff" }}>
      <HeaderWithBackAndTitle
        headertitle="Routing"
        headerColor="#fff"
        hideShadow={true}
        navigation={navigation}
        route={route}
      />
      <FlatList
        data={listData}
        keyExtractor={(item) => item.type}
        renderItem={renderItem}
      />
    </View>
  );
};
export default Routing;
